import { TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import * as selectors from '../../store/reducers';
var RoleDirective = /** @class */ (function () {
    function RoleDirective(store, templateRef, viewContainerRef) {
        var _this = this;
        this.store = store;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.roles = [];
        this.sub = this.store
            .select(selectors.org.currentOrgRoles)
            .withLatestFrom(this.store.select(selectors.auth.getRoles))
            .map(function (roles) {
            var result = roles.reduce(function (prev, next) { return prev.concat(next); }, []);
            _this.userRoles = result;
            _this._updateView();
        })
            .subscribe();
    }
    Object.defineProperty(RoleDirective.prototype, "hasRole", {
        set: function (roles) {
            if (!roles)
                roles = [];
            if (!Array.isArray(roles))
                roles = [roles];
            this.roles = roles;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    RoleDirective.prototype._checkRoles = function (roles) {
        if (!roles.length)
            return true;
        if (!this.userRoles)
            return false;
        for (var i = 0; i < roles.length; i++) {
            var role = roles[i];
            if (this.userRoles.includes(role)) {
                return true;
            }
        }
        return false;
    };
    RoleDirective.prototype._updateView = function () {
        var hasRole = this._checkRoles(this.roles);
        this.viewContainerRef.clear();
        if (hasRole) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    };
    RoleDirective.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    return RoleDirective;
}());
export { RoleDirective };
